import { SITE_FACTS } from "@shared/siteFacts";

/** A mailto link, so asking to be told when Event Suite Premium opens stores nothing on our side until the person sends the mail. */
export function premiumNotifyMailto(): string {
  const subject = "Tell me when Event Suite Premium opens";
  const body = "Hello, please email me once Event Suite Premium is open.";
  return `mailto:${SITE_FACTS.supportEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
